<template>
  <div id="appcalendar">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col cols="12" md="12">
          <TeacherCalendar />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import TeacherCalendar from "@/components/app-components/teacher/TeacherCalendar.vue";

export default {
  name: "AppCalendarView",
  components: { TeacherCalendar },
  data: () => ({}),
};
</script>